// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./FloatingBoxTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FloatingBox-module__Content__GZ4JT {
    z-index: var(--ds-menu-z-index);
    display: flex;
    max-height: 0;
    overflow: hidden;
    background: none;
    border: none;
    border-radius: var(--ds-m);
    transition: max-height var(--ds-transition-s) ease-in-out;
}

.FloatingBox-module__ContentVisible__bYkmM {
    max-height: var(--ds-190x);

    @starting-style {
        max-height: 0;
    }
}

.FloatingBox-module__HasBackdrop__GZJej::backdrop {
    background: var(--ds-floating-box-overlay-bg-color);
    backdrop-filter: blur(var(--ds-blur-4));
}

.FloatingBox-module__ShadowShallow__m_Oic {
    box-shadow: var(--ds-shadow-shallow);
}

.FloatingBox-module__ShadowMid__D7Z6r {
    box-shadow: var(--ds-shadow-mid);
}

.FloatingBox-module__ShadowDeep__cTi0A {
    box-shadow: var(--ds-shadow-deep);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Content": `FloatingBox-module__Content__GZ4JT`,
	"ContentVisible": `FloatingBox-module__ContentVisible__bYkmM`,
	"HasBackdrop": `FloatingBox-module__HasBackdrop__GZJej`,
	"ShadowShallow": `FloatingBox-module__ShadowShallow__m_Oic`,
	"ShadowMid": `FloatingBox-module__ShadowMid__D7Z6r`,
	"ShadowDeep": `FloatingBox-module__ShadowDeep__cTi0A`
};
export default ___CSS_LOADER_EXPORT___;
